import { fetchApi, getApiBaseUrl } from 'state/services/apiService';
import { AUTH_TYPES } from 'auth/state/service/authApi';

export const fetchTeamFeatures = () => {
  return fetchApi({
    url: `${getApiBaseUrl()}/features`,
    authType: AUTH_TYPES.BEARER,
  }).then(res => res.json());
};



// WEBPACK FOOTER //
// ./src/state/services/teamService.js